import SendPasswordButton from './SendPasswordButton';

export default SendPasswordButton;
